import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/ubuntu/download/6976ef121beda800149d62b7/cosmeticstore/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/home/ubuntu/download/6976ef121beda800149d62b7/cosmeticstore/src/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6976ef121beda800149d62b7/cosmeticstore/src/styles/index.css");
